import { dataLayerPush } from 'src/helpers/gtm';
import { DATA_LAYER_CLOSE_BANNER } from './constants';

export const handleAnalyticCloseBanner = () => {
  dataLayerPush({
    event: DATA_LAYER_CLOSE_BANNER,
  });
};
